module.exports = __webpack_public_path__ + "img/no-recent-trip.223d3649.svg";